// ── EVIDENCE P1.4 — reading a control's captured evidence ──────────────────────────────────────

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { ControlEvidenceRead, IntegrityHistoryRead } from '@/api/types/evidence-artifacts.types';
import { evidenceArtifactsKey } from './evidence-query-keys';

export function useControlEvidenceArtifacts(reference: string) {
  return useQuery({
    queryKey: evidenceArtifactsKey(reference),
    queryFn: async (): Promise<ControlEvidenceRead> =>
      (await apiClient.get(`/compliance/evidence/controls/${reference}/artifacts`)).data.data,
    enabled: Boolean(reference),
  });
}

/**
 * One artifact's integrity trail.
 *
 * ⚠ Enabled only when asked for: the trail is a drill-down, and fetching one per row would make a
 *   control with twenty artifacts issue twenty-one requests to render a list nobody expanded.
 */
export function useIntegrityHistory(artifactId: string | null) {
  return useQuery({
    queryKey: ['evidence-artifacts', 'history', artifactId],
    queryFn: async (): Promise<IntegrityHistoryRead> =>
      (await apiClient.get(`/compliance/evidence/artifacts/${artifactId}/history`)).data.data,
    enabled: Boolean(artifactId),
  });
}
